import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import ItemGroup from './ItemGroup';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import MainAppContext from '../../../../../../MainAppContext';
import { t } from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { IconButton } from '@fluentui/react';
import { getAdminTaskMonitoringKpiExport } from '../../../../../../services/sKPI/board.service';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { base64ToArrayBuffer, saveByteArray, showMessage } from '../../../../../../common/Helpers';
import { __MessageTypes } from '../../../../../../common/Dictionaries';

function SG3KPI_MONITORING(props) {

    const { 
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
        inputParam_ElementId = null,
    } = props;

    const contextSite = useContext(MainAppContext);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const objValues = inputParam_UseFake === true ?
            [{ name: "Name 1", color: "v", scopeValue: 47 }, { name: "Name 2", color: "r", scopeValue: 55 }]
        :
        inputParam_ComponentContent ? (inputParam_ComponentContent.items ? inputParam_ComponentContent.items.map(x => {
                return {
                    name: t(`data-lang-lbl-${x.monitoreType}`),
                    color: x.monitoreKPIColor,
                    scopeValue: x.monitoreKPIVal
                }
            }) : []) : [];

    const handleExport = () => {
        getAdminTaskMonitoringKpiExport(inputParam_ElementId,
                                        contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                                        contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
                                        contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).then((response) => {
            saveByteArray(`${t('data-lang-lbl-export-admintask-monitoringkpi')}.xlsx`, base64ToArrayBuffer(response.data));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
    } 

    const generateDom = () => {
		return  <Card className='h-100'>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            {
                                inputParam_ComponentContent !== null ?
                                <b>{inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-monitoringkpi')}</b> :
                                <b>{t('data-lang-boxname-stadistic')}</b>
                            }

                            <div className='toolbar d-flex'>
                                <HEADER_TOOLBAR
                                    inputParam_BoardStructure={inputParam_BoardStructure}
                                    inputParam_Container={inputParam_Container}
                                />
                                {
                                    (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin) &&
                                    <IconButton
                                        menuIconProps={{ iconName: 'MoreVertical' }}
                                        role="button"
                                        className="action-menu-list-toolbar"
                                        aria-haspopup
                                        styles={{ root: { float: 'left', height: 'inherit', padding: '10px' } }}
                                        menuProps={{
                                            items: [
                                                {
                                                    key: 'export',
                                                    iconProps: { iconName: 'PDF' },
                                                    text: t('data-lang-btn-exportdata'),
                                                    onClick: () => handleExport(),
                                                },
                                            ],
                                        }}
                                    />
                                }
                            </div>
                        </Card.Title>
                    </Card.Header>
					<Card.Body className='px-0 h-100'>
						<Row className='px-3'>
							{
								objValues && objValues.map((item, index) => 
									<Col key={index} className='mx-0 pb-2 px-1 mx-auto' xl={12}>
										<ItemGroup inputParam_Key={ index } inputParam_Object={item} />
									</Col>
								)
							}
                            {
                                objValues && objValues.length === 0 &&
									<Col className='mx-1'>
                                        <NoDataLayer display={true} text={t('data-lang-msg-notavailableyet')} />
									</Col>
                            }
						</Row>
                        <Row>
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </Row>
					</Card.Body>
				</Card>
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

SG3KPI_MONITORING.propTypes = {
};

export default SG3KPI_MONITORING;